import { Link } from 'react-router-dom';

const FeatureProduct = props => {
  const to = `/products/${props.id}`;
  return (
    <div className="col">
      <div className="card shadow-sm">
        <Link to={to}>
          <img className="card-img-top bg-dark cover" height="240" alt="" src={props.image} />
        </Link>
        <div className="card-body">
          <h5 className="card-title text-center">{props.name}</h5>
          <p className="card-text text-center text-muted">{props.price}$</p>
          <div className="d-grid gap-2">
            <Link to={to} className="btn btn-outline-dark">
              Detail
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeatureProduct;
